module.exports = __webpack_public_path__ + "img/header.31cc6db1.png";